/**
 *
 * Asynchronously loads the component for Trackliabilities
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Trackliabilities = lazyLoad(
  () => import('./index'),
  module => module.Trackliabilities,
);
